import { render, staticRenderFns } from "./ProcessCard.vue?vue&type=template&id=b6cb743c&scoped=true&"
import script from "./ProcessCard.vue?vue&type=script&lang=js&"
export * from "./ProcessCard.vue?vue&type=script&lang=js&"
import style0 from "./ProcessCard.vue?vue&type=style&index=0&id=b6cb743c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cb743c",
  null
  
)

export default component.exports